import {Component, OnDestroy, OnInit} from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmAccountInfo } from '../../models/account';
import { AccountService } from '../../services/account.service';
import { Store, select } from '@ngrx/store';
import * as fromStore from '../../store';
import { Router, ActivatedRoute } from '@angular/router';
import { WindowService } from '../../services/window.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  standalone: false,
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.css']
})
export class ActivateAccountComponent implements OnInit, OnDestroy {
  ConfirmAccountInfo: ConfirmAccountInfo = {
    hashString: ''
  };

  activate_result_status = '';
  result_result_icon = '';
  activate_result_type = '';
  activate_result = '';
  msgs = [];
  logoPath: string;
  hostName: string;
  private componentDestroyed = new Subject();
  constructor(
    private store: Store<fromStore.State>,
    private router: Router,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private apiService: AccountService,
    private windowService: WindowService,
    private translateService: TranslateService) {
    this.hostName = this.windowService.getHostName();
    this.store.select(fromStore.getRegions).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.length > 0) {
        const region = this.windowService.getLogoRegion(res);
        if (typeof region !== 'undefined' && region !== null) {
          this.logoPath = region.Note;
        }
        // const logoPath = res.find(i =>　i.Region.toLowerCase() === this.hostName.toLowerCase()).Note;
        // if (typeof logoPath !== 'undefined' && logoPath !== null) {
        //   this.logoPath = logoPath;
        // }
      }
    });
  }

  ngOnInit() {
    this.ngxService.start();
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-login');
    body.classList.remove('body-landing');
    body.classList.remove('mobile-toggle');
    this.route.queryParams.subscribe((value) => {
      this.ConfirmAccountInfo.hashString = value['hashStr'];
    });
    this.apiService.ConfirmAccount(this.ConfirmAccountInfo).subscribe(res => {
      this.activate_result_status = res.Flag ? 'normal' : 'critical';
      this.result_result_icon = res.Flag ? 'fa-check-circle' : 'fa-times-circle';
      this.activate_result_type = res.Flag ? 'Success' : 'Error';
      this.activate_result = res.Flag ?
        this.translateService.instant(TRANSLATE('Your account has been activated successfully.')) :
        this.translateService.instant(TRANSLATE('The link has either expired or is no longer valid.'));
    });
    this.ngxService.stop();
  }

  confirmAccount() {
    this.router.navigate(['/login']);
  }
  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }
}
